import Vue from "vue";
import VueRouter from "vue-router";

import routes from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { x: 0, y: 0 };
  }
});

// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect to login page.
//     if (!auth.loggedIn()) {
//       next({
//         path: '/login',
//         query: { redirect: to.fullPath }
//       })
//     } else {
//       next()
//     }
//   } else {
//     next() // make sure to always call next()!
//   }
// })

router.beforeEach((to, from, next) => {
  let app = router.app.$GAUserAuth;

  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (!app.user.isAuthenticated) {
      //authentication is required. Trigger the sign in process, including the return URI
      app.authenticate(to.path).then(() => {
        next();
      });
    } else {
      if (to.matched.some(route => route.meta.role)) {
        app.isInRole(to.meta.role).then(resp => {
          if (resp) {
            next();
          } else {
            next({ name: "unauthorized" });
          }
        });
      } else if (to.matched.some(route => route.meta.function)) {
        app.canRead(to.meta.function).then(resp => {
          if (resp) {
            next();
          } else {
            next({ name: "unauthorized" });
          }
        });
      } else if (
        !to.matched.some(route => route.meta.role) &&
        !to.matched.some(route => route.meta.function)
      ) {
        next();
      } else {
        next({ name: "unauthorized" });
      }
    }
  } else {
    next();
  }
});

export default router;
